import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import CookieConsent from '@/components/CookieConsent';
import ScrollToTop from '@/components/ScrollToTop';
import VisualizerBackground from '@/components/VisualizerBackground';
import Visualizer from '@/components/Visualizer';
import { Music } from 'lucide-react';

// Pages
import Home from '@/pages/Index';
import About from '@/pages/About';
import Videos from '@/pages/Videos';
import Services from '@/pages/Services';
import Contact from '@/pages/Contact';
import Testimonials from '@/pages/Testimonials';
import Privacy from '@/pages/Privacy';
import Terms from '@/pages/Terms';
import NotFound from '@/pages/NotFound';
import Success from '@/pages/Success';
import Admin from '@/pages/Admin';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-drummer-dark text-white">
        <Navigation />
        <VisualizerBackground />
        <Visualizer />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/success" element={<Success />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/dashboard" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <CookieConsent />
      </div>
    </Router>
  );
};

export default App;
